import React, { Component } from "react";
//import ChartistGraph from "react-chartist";
import { Grid as Container, Row, Col } from "react-bootstrap";
import TimeAgo from "timeago-react"; // var TimeAgo = require('timeago-react');
//import timeago from "timeago.js";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
//timeago.register("pl_PL", require("timeago.js/locales.js"));

//import { Card } from "components/Card/Card.jsx";

//import { Tasks } from "components/Tasks/Tasks.jsx";

class Dashboard2 extends Component {
  // constructor(props) {
  //   super(props);
  // }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  getDeviceData = id => {
    // console.log(this.props.lastMeasurement[id][0].value);
    var data = [];
    data = [
      this.props.lastMeasurement[id][0].value.toFixed(2) + " l ",
      this.props.lastMeasurement[id][1].value.toFixed(2) + "°C"
    ];
    return data;
  };

  render() {
    console.log(this.props.device[0].id);
    return (
      <div className="content">
        <Container fluid>
          <Row>
            {this.props.device.map((device, key) => {
              let tempDate = new Date(
                1000 * this.props.lastMessage[device.id][0].timestamp
              );
              return (
                <Col lg={4} sm={6} key={key}>
                  <StatsCard
                    bigIcon={<i className="pe-7s-info text-primary" />}
                    statsText={device.desc}
                    statsValue={this.getDeviceData(device.id)}
                    statsIcon={<i className="fa clock" />}
                    statsIconText={
                      <TimeAgo datetime={tempDate.getTime()} locale="pl_PL" />
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    );
  }
}

export default Dashboard2;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard2.jsx